import React from "react";
import { HowDidYouHearAboutUs } from "../Data/Functions/HowDidYouHear";
import { useCheckoutT } from "../i18n/checkout";
import { howDidYouHearOptions } from "../i18n/checkout/data";
import "./HowDidYouHearSelect.css";

// "How did you hear about us?" as a dropdown with nothing chosen at first, and a
// text box for the options that ask for a detail (a second dropdown when the
// option has a list, like which AI assistant).
const HowDidYouHearSelect = ({ selectedOption, inputText, onSelect, onInputChange, id = "howDidYouHear" }) => {
  // The labels follow the checkout's language; the values (what office sees) don't change.
  const { t, lang } = useCheckoutT();
  const shown = howDidYouHearOptions(HowDidYouHearAboutUs, lang);
  const option = shown.find(o => o.value === selectedOption);
  return (
    <div className="hdyhSelectWrap">
      <label className="hdyhLabel" htmlFor={id}>{t("contact.chooseOne")}</label>
      <select
        id={id}
        data-field="hear"
        className={`hdyhSelect ${selectedOption ? "" : "hdyhSelectEmpty"}`}
        value={option ? option.value : ""}
        onChange={(e) => onSelect(HowDidYouHearAboutUs.find(o => o.value === e.target.value) || null)}
      >
        <option value="" disabled>{t("contact.selectOption")}</option>
        {shown.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      {option && option.extraChoices &&
        <select
          className={`hdyhSelect ${inputText ? "" : "hdyhSelectEmpty"}`}
          data-field="hearOther"
          aria-label={option.extraInputLabel}
          value={option.extraChoices.some(c => c.value === inputText) ? inputText : ""}
          onChange={(e) => onInputChange(e.target.value)}
        >
          <option value="" disabled>{option.extraInputLabel}</option>
          {option.extraChoices.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
        </select>
      }
      {option && option.extraInput && !option.extraChoices &&
        <input
          type="text"
          className="hdyhInput"
          data-field="hearOther"
          aria-label={option.extraInputLabel}
          placeholder={option.extraInputLabel}
          value={inputText || ""}
          onChange={(e) => onInputChange(e.target.value)}
        />
      }
    </div>
  );
};

export default HowDidYouHearSelect;
